// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
// import vueRouter from 'vue-router';
import axios from "axios";

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyLoad from 'vue-lazyload'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(VueLazyLoad,{
  // error:'./assets/banner1.png',                        //报错需要的图片
  loading:require('../static/assets/guanyuwomen@1x.png')					// 替换需要的图片
})

Vue.prototype.$axios = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js